const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

// // 系统设置
const sysOptions = r =>
  require.ensure(
    [],
    () => r(require('@/modules/sysOptions/sysOptions.vue')),
    'settings'
  )
const dictionary = r =>
  require.ensure(
    [],
    () => r(require('@/modules//zkCdpPage/settings/dictionary.vue')),
    'settings'
  )
const sysTemplate = r =>
  require.ensure(
    [],
    () => r(require('@/modules/sysOptions/sysTemplate.vue')),
    'settings'
  )
const eventCode = r =>
  require.ensure(
    [],
    () => r(require('@/modules/sysOptions/sysEventCode.vue')),
    'setting'
  )

const quartzJob = r =>
  require.ensure(
    [],
    () => r(require('@/modules/sysOptions/quartzJob.vue')),
    'settings'
  )

const settingsRouter = {
  path: '/settings',
  name: 'settings',
  component: Layout,
  meta: {
    id: 'sys-menu-c',
    auth: true
  },
  children: [
    {
      path: 'sysOptions',
      name: 'sysOptions',
      component: sysOptions,
      meta: {
        id: 'sys-menu-c-1',
        auth: true
      }
    },
    {
      path: 'dictionary',
      name: 'dictionary',
      component: dictionary,
      meta: {
        id: 'sys-menu-c-2',
        auth: true
      }
    },
    {
      path: 'quartzJob',
      name: 'quartzJob',
      component: quartzJob,
      meta: {
        id: 'ca5a08cc12514eecb13fcf635451476e',
        auth: true
      }
    },
    {
      path: 'sysTemplate',
      name: 'sysTemplate',
      component: sysTemplate,
      meta: {
        id: 'a798045c42eb491eb027fe67590b8819',
        auth: true
      }
    },
    {
      path: 'eventCode',
      name: 'eventCode',
      component: eventCode,
      meta: {
        id: '4536dce572d745b89fc3c8e7c6b28da2',
        auth: true
      }
    }
  ]
}
export default settingsRouter



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/settings.js